const initialState = {
  insuranceDisabling: null,
};

export const experimentReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "EXPERIMENT_SET_INSURANCE_DISABLING": {
      const { insuranceDisabling } = action.payload;
      return {
        insuranceDisabling,
      };
    }
    default:
      return state;
  }
};
